import tradutecLogoWhite from "../assets/img/tradutec_logo_2026_white.png";

function Footer() {
    return (
        <footer className="site-footer">
            <div className="wrap">
                <div className="footer-grid">
                    <div>
                        <a className="logo" href="https://tradutecperu.com/">
                            <img
                                src={tradutecLogoWhite}
                                alt="Tradutec Perú"
                            />
                        </a>
                        <p className="tag">Traducción que conecta al mundo.</p>
                    </div>

                    <div>
                        <div className="foot-h">Contáctanos</div>
                        <ul className="fcontact">
                            <li>
                                <i className="fas fa-envelope"></i>{" "}
                                <a href="mailto:cotizaciones@tradutecperu.com">
                                    cotizaciones@tradutecperu.com
                                </a>
                            </li>
                            <li>
                                <i className="fas fa-phone"></i>{" "}
                                <a href="tel:+51941175281">+51 941 175 281</a>
                            </li>
                            <li>
                                <i className="fas fa-location-dot"></i>
                                {" "}Calle Ramón Ribeyro 1062, Barranco, Lima-Perú
                            </li>
                        </ul>
                    </div>

                    <div>
                        <div className="foot-h">Síguenos</div>
                        <div className="fsocial">
                            <a
                                href="https://www.facebook.com/tradutecperu"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Facebook"
                            >
                                <i className="fab fa-facebook-f"></i>
                            </a>

                            <a
                                href="https://www.instagram.com/tradutec.peru"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="Instagram"
                            >
                                <i className="fab fa-instagram"></i>
                            </a>

                            <a
                                href="https://pe.linkedin.com/company/tradutec-peru"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="LinkedIn"
                            >
                                <i className="fab fa-linkedin-in"></i>
                            </a>

                            <a
                                href="https://wa.me/51941175281"
                                target="_blank"
                                rel="noopener noreferrer"
                                aria-label="WhatsApp"
                            >
                                <i className="fab fa-whatsapp"></i>
                            </a>
                        </div>
                    </div>
                </div>

                <div className="copyright">
                    © 2024 Tradutec Perú. Todos los derechos reservados.
                </div>
            </div>
        </footer>
    );
}

export default Footer;